import React from "react"

import classNames from "classnames"

type BadgeProps = {
  children: React.ReactNode
  className?: string
  variant?: "default" | "outline"
}

const baseStyles =
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"

const variants = {
  default:
    "bg-primary text-primary-foreground border-transparent hover:bg-primary/80",
  outline:
    "border border-border text-foreground bg-transparent hover:bg-accent",
}

export const Badge = ({
  children,
  className,
  variant = "default",
}: BadgeProps) => (
  <div className={classNames(baseStyles, variants[variant], className)}>
    {children}
  </div>
)
